import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SideBarComponent } from '../components/side-bar/side-bar.component';
import { FeedsComponent } from '../components/feeds/feeds.component';
import { MessagesComponent } from '../components/messages/messages.component';
import { MessageComponent } from '../components/message/message.component';
import { HeaderComponent } from '../components/header/header.component';
import { LedgerComponent } from '../components/ledger/ledger.component';
import { ProfileCardComponent } from '../components/profile-card/profile-card.component';
// import { LoginComponent } from '../components/login/login.component';
import { PostComponent } from '../components/post/post.component';
import { GroupCardComponent } from '../components/group-card/group-card.component';
import { SelectGroupComponent } from '../components/select-group/select-group.component';
import { SquareCardComponent } from '../components/square-card/square-card.component';
import { CoinsHistoryComponent } from '../components/coins-history/coins-history.component';
import { StoriesComponent } from '../components/stories/stories.component';
import { SettingsComponent } from '../components/settings/settings.component';
import { ArticleComponent } from '../components/article/article.component';
import { EditProfileComponent } from '../components/edit-profile/edit-profile.component';
import { AddEditGroupComponent } from '../components/add-edit-group/add-edit-group.component';
import { AddEditSquareComponent } from '../components/add-edit-square/add-edit-square.component';
import { AcceptRejectMemberComponent } from '../components/accept-reject-member/accept-reject-member.component';
import { EditAboutComponent } from '../components/edit-about/edit-about.component';
import { EditCareerListComponent } from '../components/edit-career-list/edit-career-list.component';
import { ShareOnWebComponent } from '../components/share-on-web/share-on-web.component';
import { RouterModule } from '@angular/router';
import { PipesModule } from '../pipes/pipes.module';
import { DirectiveModule } from '../directives/directives.module';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgxDocViewerModule } from 'ngx-doc-viewer'; // <- import PdfViewerModule
import { DocumentViewerComponent } from './document-viewer/document-viewer.component';
import { MarketingHeaderComponent } from './marketing-header/marketing-header.component';
import { MarketingFooterComponent } from './marketing-footer/marketing-footer.component';
import { VideoOverlayComponent } from './video-overlay/video-overlay.component';
import { DeliveryDetailsComponent } from './delivery-details/delivery-details.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    ReactiveFormsModule,
    PipesModule,
    DirectiveModule,
    ShareButtonsModule,
    ShareIconsModule,
    ScrollingModule,
    NgxDocViewerModule
  ],
  exports: [
    SideBarComponent,
    FeedsComponent,
    MessagesComponent,
    HeaderComponent,
    MarketingHeaderComponent,
    MarketingFooterComponent,
  VideoOverlayComponent,
    // LoginComponent,
    DocumentViewerComponent,
    PostComponent,
    StoriesComponent,
    ArticleComponent,
    SettingsComponent,
    MessageComponent,
    EditProfileComponent,
    EditAboutComponent,
    EditCareerListComponent,
    AddEditGroupComponent,
    AcceptRejectMemberComponent,
    LedgerComponent,
    ProfileCardComponent,
    GroupCardComponent,
    CoinsHistoryComponent,
    ShareOnWebComponent,
    AddEditSquareComponent,
    SquareCardComponent,
    SelectGroupComponent,
    DeliveryDetailsComponent
  ],
  declarations: [SideBarComponent,
    ArticleComponent,
    FeedsComponent,
    MessagesComponent,
    HeaderComponent,
    MarketingHeaderComponent,
    MarketingFooterComponent,
    VideoOverlayComponent,
    // LoginComponent,
    PostComponent,
    StoriesComponent,
    MessageComponent,
    EditProfileComponent,
    EditAboutComponent,
    EditCareerListComponent,
    AddEditGroupComponent,
    SettingsComponent,
    AcceptRejectMemberComponent,
    LedgerComponent,
    ProfileCardComponent,
    GroupCardComponent,
    CoinsHistoryComponent,
    ShareOnWebComponent,
    AddEditSquareComponent,
    SquareCardComponent,
    SelectGroupComponent,
    DocumentViewerComponent,
    DeliveryDetailsComponent
  ]
})
export class ComponentModule { }
